/* ==========================================================================
   La Pradera — Cart AJAX
   Event delegation: one listener for all .lp-product-card__add buttons.
   Integrates with Dawn's cart-drawer (renderContents pattern).
   ========================================================================== */

(function () {
  var DRAWER_SECTIONS = 'cart-drawer,cart-icon-bubble';
  var FEEDBACK_MS = 1200;
  var ERROR_MS = 2400;
  var cartUpdateSubscribed = false;

  function setLabel(btn, name) {
    btn.querySelectorAll('[data-label-default],[data-label-loading],[data-label-success],[data-label-error]')
      .forEach(function (el) { el.hidden = true; });
    var target = btn.querySelector('[data-label-' + name + ']');
    if (target) target.hidden = false;
  }

  function setState(btn, state) {
    btn.classList.remove('lp-product-card__add--loading', 'lp-product-card__add--success', 'lp-product-card__add--error');
    if (state === 'loading') {
      btn.disabled = true;
      btn.classList.add('lp-product-card__add--loading');
      setLabel(btn, 'loading');
    } else if (state === 'success') {
      btn.disabled = true;
      btn.classList.add('lp-product-card__add--success');
      setLabel(btn, 'success');
    } else if (state === 'error') {
      btn.disabled = false;
      btn.classList.add('lp-product-card__add--error');
      setLabel(btn, 'error');
    } else {
      btn.disabled = false;
      setLabel(btn, 'default');
    }
  }

  function updateHeaderCartCount(itemCount) {
    document.querySelectorAll('.lp-header__action--cart').forEach(function (cartLink) {
      // Update or inject badge
      var badge = cartLink.querySelector('.lp-header__cart-count');
      if (itemCount > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'lp-header__cart-count';
          badge.setAttribute('aria-hidden', 'true');
          cartLink.appendChild(badge);
        }
        badge.textContent = itemCount;
      } else if (badge) {
        badge.remove();
      }

      // Update aria-label count "(N)"
      var current = cartLink.getAttribute('aria-label') || '';
      if (/\(\d+\)/.test(current)) {
        cartLink.setAttribute('aria-label', current.replace(/\(\d+\)/, '(' + itemCount + ')'));
      }
    });
  }

  function replaceSectionDom(html, hostSelector, innerSelector) {
    var hostEl = document.querySelector(hostSelector);
    if (!hostEl || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = innerSelector ? doc.querySelector(innerSelector) : doc.querySelector('.shopify-section');
    if (src) hostEl.innerHTML = src.innerHTML;
  }

  function openDawnDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') {
      console.warn('[lp-cart] cart-drawer element or .open() not available; item was added but drawer cannot open visually.');
      return false;
    }
    try {
      drawer.open();
      return true;
    } catch (err) {
      console.warn('[lp-cart] cart-drawer.open() threw:', err);
      return false;
    }
  }

  function manualSwapAndOpen(data) {
    if (!data || !data.sections) return;
    if (data.sections['cart-drawer']) {
      replaceSectionDom(data.sections['cart-drawer'], '#CartDrawer', '#CartDrawer');
    }
    if (data.sections['cart-icon-bubble']) {
      replaceSectionDom(data.sections['cart-icon-bubble'], '#cart-icon-bubble');
    }
    // Critical: drop is-empty from the outer <cart-drawer>, otherwise Dawn s
    // open() will try to focus .drawer__inner-empty (which no longer exists
    // now that the cart has items) and trapFocus crashes on null.
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.remove('is-empty');
    openDawnDrawer();
  }

  async function addToCart(variantId) {
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript, application/json'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: DRAWER_SECTIONS,
        sections_url: window.location.pathname
      })
    });

    if (!response.ok) {
      var errBody = null;
      try { errBody = await response.json(); } catch (e) {}
      var err = new Error((errBody && errBody.description) || 'Add to cart failed');
      err.status = response.status;
      throw err;
    }
    return response.json();
  }

  async function fetchCartCount() {
    try {
      var response = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      if (!response.ok) return null;
      var cart = await response.json();
      return cart.item_count;
    } catch (e) {
      return null;
    }
  }

  // Subscribe to Dawn s cart-update pub/sub so the custom header badge
  // refreshes when the user changes quantity or deletes a line directly
  // from the cart drawer (those flows do NOT go through our add handler).
  // Dawn s subscribe() and PUB_SUB_EVENTS are defined in pubsub.js +
  // global.js, both loaded before this file in layout/theme.liquid.
  //
  // Pubsub.js load order can vary, so we retry the wiring across three
  // lifecycle points (IIFE boot, DOMContentLoaded, setTimeout 100ms) and
  // guard against double-subscription with the module-scope flag above.
  function trySubscribeCartUpdate() {
    if (cartUpdateSubscribed) return;
    if (typeof window.subscribe !== 'function') return;
    if (!window.PUB_SUB_EVENTS || !window.PUB_SUB_EVENTS.cartUpdate) return;

    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      var count = null;

      // Dawn s cartUpdate payload shape varies. Try the documented shape
      // first, then the raw-cart fallback, then a CustomEvent-style detail,
      // then the event itself if someone passed a bare number.
      if (event && event.cartData && typeof event.cartData.item_count === 'number') {
        count = event.cartData.item_count;
      } else if (event && typeof event.cartData === 'number') {
        count = event.cartData;
      } else if (event && event.detail && typeof event.detail.item_count === 'number') {
        count = event.detail.item_count;
      } else if (typeof event === 'number') {
        count = event;
      }

      if (typeof count === 'number') {
        updateHeaderCartCount(count);
      } else {
        fetchCartCount().then(function (c) { if (c !== null) updateHeaderCartCount(c); });
      }
    });
    cartUpdateSubscribed = true;
  }

  trySubscribeCartUpdate();
  if (!cartUpdateSubscribed) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', trySubscribeCartUpdate);
    } else {
      // DOM already parsed; queue a microtask retry alongside the timeout.
      trySubscribeCartUpdate();
    }
    setTimeout(trySubscribeCartUpdate, 100);
  }

  // Belt-and-suspenders fallback: even if pub-sub never wires up (e.g.
  // pubsub.js fails to load), Dawn s trash icon inside the drawer is a
  // <cart-remove-button>. Delegate on body so the listener survives Dawn s
  // section-rerender, and refresh the badge ~300ms after the click (after
  // Dawn s internal /cart/change.js round-trip completes).
  document.body.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('cart-remove-button');
    if (!removeBtn) return;
    setTimeout(function () {
      fetchCartCount().then(function (c) {
        if (c === null) return;
        // updateHeaderCartCount(0) already handles the empty-cart case by
        // removing the badge element entirely.
        updateHeaderCartCount(c);
      });
    }, 300);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.lp-product-card__add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    setState(btn, 'loading');

    addToCart(variantId).then(function (data) {
      var drawer = document.querySelector('cart-drawer');

      // Prefer Dawn s built-in renderContents — it knows how to swap each
      // sub-section, strip the is-empty class on the outer element, and
      // open the drawer in one coherent step. Falls back to a manual swap
      // only if the custom element is not present.
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        try {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } catch (e) {
          console.warn('[lp-cart] drawer.renderContents threw, falling back to manual swap:', e);
          manualSwapAndOpen(data);
        }
      } else {
        manualSwapAndOpen(data);
      }

      // Mirror count into the custom header badge (independent of Dawn s bubble).
      return fetchCartCount().then(function (count) {
        if (count !== null) updateHeaderCartCount(count);
        setState(btn, 'success');
        setTimeout(function () { setState(btn, 'default'); }, FEEDBACK_MS);
      });
    }).catch(function () {
      setState(btn, 'error');
      setTimeout(function () { setState(btn, 'default'); }, ERROR_MS);
    });
  });
})();
